<template>
  <scroll-view :scroll="true" class="homeCatalog-template1">
    <div v-if="login">
      <div class="div-swipe">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item v-for="(item, index) in imgList" :key="index">
            <img :src="item.image_text" class="van-swipe-item-img" @click="locationTap(item.link)" />
          </van-swipe-item>
        </van-swipe>
      </div>
      <ability></ability>
      <div class="homeCatalog-boder"></div>

      <div v-for="(item, index) in getIndexDirList" :key="index">
        <div class="homeCatalog-goods">
          <div class="homeCatalog-goods-head">
            <div>
              <div class="homeCatalog-goods-head-div"></div>
              <div style="margin: 0 2rem;">{{ item.name }}</div>
              <div class="homeCatalog-goods-head-div"></div>
            </div>
            <div class="homeCatalog-goods-absolute" @click="moreTap(item)">
              更多
              <span class="iconfont icon-046" style="margin-left: 0.2rem;"></span>
            </div>
          </div>
          <div class="homeCatalog-goods-body">
            <goods-view
              v-for="(infoItem, itemIndex) in item.recom_images"
              :key="itemIndex"
              :item="infoItem"
              :goodsobject="{ list: item.recom_images, index: itemIndex }"
              :close="false"
            ></goods-view>
          </div>
        </div>
        <div class="homeCatalog-boder"></div>
      </div>
      <div style="margin-bottom: 50px;"></div>
    </div>
    <div v-else>
      <loadMore :loadingType="1" style="width: 100%;"></loadMore>
    </div>
  </scroll-view>
</template>

<script>
import { Swipe, SwipeItem } from 'vant'
import {
  getlist, getIndexDir,
} from '@/request/api.js'
import config from '@/assets/js/config.js'
import ability from './ability.vue'

export default {
  mixins: [config],
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    ability,
  },
  data () {
    return {
      imgList: [],
      getIndexDirList: [],
      login: false,
    }
  },
  created () {
    this.getIndexDir_load()
    this.getlist_load()
  },
  methods: {
    locationTap (url) {
      if (url.length != 0) {
        window.location = url
      }
    },
    moreTap (item) {
      const { album_alias } = this.$store.state.loginInfo
      this.$router.push({
        path: `/homeCatalog/more?directory_id=${item.directory_id}&alias=${album_alias}&title=${encodeURI(item.name)}`,
      })
    },
    async getlist_load () {
      const res = await getlist('')
      this.imgList = res.data
    },
    async getIndexDir_load () {
      const res = await getIndexDir({ albumAlias: this.$store.state.loginInfo.album_alias })
      this.getIndexDirList = res.data
      this.login = true
    },
  },
};
</script>

<style lang="less">
.homeCatalog-template1 {
  .div-swipe {
    width: 100%;
    padding-top: 56.25%;
    position: relative;
  }

  .my-swipe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .van-swipe__track,
  .van-swipe-item-img {
    width: 100% !important;
    height: 100% !important;
  }

  .homeCatalog-boder {
    width: 100%;
    height: 10px;
    background-color: #f4f4f4;
  }

  .homeCatalog-goods {
    width: 96%;
    padding: 0 2%;
    display: flex;
    flex-direction: column;
    font-size: 1.2rem;
  }

  .homeCatalog-goods-head {
    width: 100%;
    background-color: #ffffff;
    padding: 1rem 0;
    border-bottom: 1px solid #f4f4f4;
    margin-bottom: 1rem;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    position: relative;
  }

  .homeCatalog-goods-head > div:nth-child(1) {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
  }

  .homeCatalog-goods-head-div {
    width: 3rem;
    height: 0.2rem;
    background-color: #f4f4f4;
  }

  .homeCatalog-goods-absolute {
    position: absolute;
    color: #999;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: 0.6rem;
  }

  .homeCatalog-goods-body {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
  }
}
</style>
